<template>
  <div>
    <div class="wx-demo">
      <div class="wx-tips">本页仅测试使用，请勿泄漏所有链接</div>
      <div class="wx-item">
        <h3>使用猎上</h3>
        <div class="item-link">
          <van-button plain type="primary" size="small" @click="golink('/account')">合作入驻</van-button>
        </div>
      </div>

      <div class="wx-item">
        <h3>猎上职位</h3>
        <div class="item-link">
          <van-button plain type="primary" size="small" @click="golink('/cdy')">成单易</van-button>
          <van-button plain type="primary" size="small" @click="golink('/recruit')">专场活动</van-button>
          <van-button plain type="primary" size="small" @click="golink('/employer')">新上雇主</van-button>
          <van-button plain type="primary" size="small" @click="golink('/positions')">新发职位</van-button>
        </div>
      </div>

      <div class="wx-item">
        <h3>用户中心</h3>
        <div class="item-link">
          <van-button plain type="primary" size="small" @click="golink('/aiMatch')">AI匹配</van-button>
          <van-button plain type="primary" size="small" @click="golink('/pa')">PA派单</van-button>
          <van-button plain type="primary" size="small" @click="golink('/subscribe')">我的订阅</van-button>
          <van-button plain type="primary" size="small" @click="golink('/order')">我的订单</van-button>
        </div>
      </div>

      <div class="wx-item">
        <h3>账号</h3>
        <div class="item-link">
          <van-button plain type="primary" size="small" @click="golink('/account')">注册/绑定</van-button>
          <van-button plain type="primary" size="small" @click="clearCookie">清除cookie</van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.wx-tips {
  background-color: #ff976a;
  color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  text-align: center;
  padding: 5px 0px;
}
.wx-demo {
  padding-top: 30px;

  .wx-item {
    padding: 20px 0;
    h3 {
      text-align: left;
      font-size: 16px;
      margin-left: 10px;
    }
  }
  .item-link {
    margin-top: 20px;
    .van-button {
      margin: 0 10px;
    }
  }
}
</style>

<script>
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {
    golink(path) {
      this.$router.push({ path });
    },
    clearCookie() {
      function setCookie(name, value, seconds) {
        seconds = seconds || 0; //seconds有值就直接赋值，没有为0，这个根php不一样。
        var expires = "";
        if (seconds != 0) {
          //设置cookie生存时间
          var date = new Date();
          date.setTime(date.getTime() + seconds * 1000);
          expires = "; expires=" + date.toGMTString();
        }
        document.cookie = name + "=" + escape(value) + expires + "; path=/"; //转码并赋值
      }
      setCookie('mp_token',"", -1);
      setCookie('userId',"", -1);

    }
  },
  watch: {
    $route() {}
  },
  mounted() {}
};
</script>
